var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"chart",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.chartOptions.name}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }